import { render, staticRenderFns } from "./BnftWishlistsAdminWishlistTable.vue?vue&type=template&id=03383c2e&"
import script from "./BnftWishlistsAdminWishlistTable.vue?vue&type=script&lang=js&"
export * from "./BnftWishlistsAdminWishlistTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VImg } from 'vuetify/lib/components/VImg';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VContainer,VDataTable,VImg,VOverlay,VSubheader})
